import { Template } from '@pdfme/common';

export const getSampleCheckTemplate = (): Template => ({
  basePdf: examplePdfb64,
  schemas: [
    [
      {
        type: 'text',
        position: { x: 42.69, y: 148.53 },
        width: 27.53,
        height: 7.08,
        fontSize: 12,
        fontName: 'liberationSans',
        opacity: 1,
        characterSpacing: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        lineHeight: 1,
        fontColor: '#000000',
        name: 'nameOnCheckMiddle',
        content: '{{nameOnCheckMiddle}}',
      },
      {
        type: 'text',
        position: { x: 12.05, y: 185.1 },
        width: 28.06,
        height: 7.08,
        fontSize: 12,
        fontName: 'liberationSansBold',
        opacity: 1,
        characterSpacing: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        lineHeight: 1,
        fontColor: '#000000',
        rotate: 0,
        name: 'checkDateLower',
        content: '{{checkDateLower}}',
      },
      {
        type: 'text',
        position: { x: 176.36, y: 185.05 },
        width: 37.05,
        height: 7.08,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSansBold',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'checkNumberLower',
        content: '{{checkNumberLower}}',
      },
      {
        type: 'text',
        position: { x: 63.81, y: 185.02 },
        width: 72.75,
        height: 7.31,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSansBold',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'nameOnCheckLower',
        content: '{{nameOnCheckLower}}',
      },
      {
        type: 'text',
        position: { x: 95.62, y: 195.65 },
        width: 40.75,
        height: 16.05,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'payTo',
        content: '{{payTo}}',
      },
      {
        type: 'text',
        position: { x: 64.33, y: 236.05 },
        width: 39.17,
        height: 7.86,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSansBold',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'referenceId',
        content: '{{referenceId}}',
      },
      {
        type: 'text',
        position: { x: 176.36, y: 5.98 },
        width: 37.05,
        height: 6.02,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSansBold',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'checkNumber',
        content: '{{checkNumber}}',
      },
      {
        type: 'text',
        position: { x: 172.18, y: 18.21 },
        width: 28.06,
        height: 6.02,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'checkDate',
        content: '{{checkDate}}',
      },
      {
        type: 'text',
        position: { x: 167.48, y: 32.55 },
        width: 29.65,
        height: 6.55,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'bottom',
        fontName: 'liberationSansBold',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'amount',
        content: '{{amount}}',
      },
      {
        type: 'text',
        position: { x: 34.29, y: 31.65 },
        width: 112.46,
        height: 6.55,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'nameOnCheck',
        content: '{{nameOnCheck}}',
      },
      {
        type: 'text',
        position: { x: 13.44, y: 42.29 },
        width: 150.03,
        height: 6.55,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'amountInText',
        content: '{{amountInText}}',
      },
      {
        type: 'text',
        position: { x: 24.08, y: 61.39 },
        width: 77.01,
        height: 6.55,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'memo',
        content: '{{memo}}',
      },
      {
        type: 'text',
        position: { x: 29.11, y: 77.69 },
        width: 132.84,
        height: 6.29,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'bottom',
        fontName: 'micrEncoding',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'bankInfo',
        content: '{{bankInfo}}',
      },
      {
        name: 'logo',
        type: 'image',
        content: '',
        position: { x: 2.11, y: 0.52 },
        width: 39.69,
        height: 28.84,
        rotate: 0,
        opacity: 1,
        required: false,
      },
      {
        name: 'companyAddress',
        type: 'text',
        position: { x: 42.07, y: 6.48 },
        required: false,
        content: '{{companyAddress}}',
        width: 61.91,
        height: 22.22,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'middle',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 1,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        readOnly: false,
        fontName: 'Roboto',
      },
      {
        type: 'text',
        position: { x: 95.83, y: 216.24 },
        width: 40.75,
        height: 16.05,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'payFrom',
        content: '{{payFrom}} ',
        readOnly: false,
      },
      {
        name: 'signature',
        type: 'image',
        content: '',
        position: { x: 152.41, y: 49.79 },
        width: 46.3,
        height: 17.46,
        rotate: 0,
        opacity: 1,
        required: false,
        readOnly: false,
      },
      {
        type: 'text',
        position: { x: 8.94, y: 259.77 },
        width: 202.94,
        height: 6.35,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontName: 'liberationSans',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        name: 'memoBottom',
        content: '{{memoBottom}}',
        readOnly: false,
      },
      {
        name: 'compnayAddressMiddle',
        type: 'text',
        content: '{{compnayAddressMiddle',
        position: { x: 30.16, y: 105.84 },
        width: 42.6,
        height: 14.02,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'companyName',
        type: 'text',
        content: '{{companyName}}',
        position: { x: 78.58, y: 101.07 },
        width: 44.71,
        height: 6.61,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'bankName',
        type: 'text',
        content: '{{bankName}}',
        position: { x: 104.51, y: 6.35 },
        width: 67.2,
        height: 9,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'middle',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
      },
    ],
  ],
});

export const getSampleCheckTemplateWhitePaper = (): Template => ({
  basePdf: examplePdfb64,
  schemas: [
    [
      {
        type: 'qrcode',
        position: { x: 104.25, y: 242.53 },
        width: 21.24,
        height: 20.44,
        name: 'owner',
        content: '',
      },
      {
        type: 'text',
        position: { x: 40.22, y: 76.73 },
        width: 132.84,
        height: 6.29,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'middle',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'micrEncoding',
        name: 'bankInfo',
        content: '{{bankInfo}}',
      },
      {
        type: 'text',
        position: { x: 27.52, y: 61.13 },
        width: 77.01,
        height: 6.55,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'memo',
        content: '{{memo}}',
      },
      {
        type: 'text',
        position: { x: 16.35, y: 44.94 },
        width: 150.03,
        height: 6.55,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'amountInText',
        content: '{{amountInText}}',
      },
      {
        type: 'text',
        position: { x: 37.2, y: 34.03 },
        width: 112.46,
        height: 6.55,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'nameOnCheck',
        content: '{{nameOnCheck}}',
      },
      {
        type: 'text',
        position: { x: 167.74, y: 34.4 },
        width: 26.74,
        height: 6.55,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'bottom',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSansBold',
        name: 'amount',
        content: '{{amount}}',
      },
      {
        type: 'text',
        position: { x: 166.89, y: 22.44 },
        width: 28.06,
        height: 6.02,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'bottom',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'checkDate',
        content: '{{checkDate}}',
      },
      {
        type: 'text',
        position: { x: 167.63, y: 11.54 },
        width: 37.05,
        height: 6.02,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'bottom',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSansBold',
        name: 'checkNumber',
        content: '{{checkNumber}}',
      },
      {
        type: 'text',
        position: { x: 36.2, y: 255.16 },
        width: 62.98,
        height: 4.43,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'bottom',
        fontSize: 10,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'verifyCode',
        content: '{{verifyCode}}',
      },
      {
        type: 'text',
        position: { x: 7.9, y: 260.25 },
        width: 101.34,
        height: 4.5,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'middle',
        fontSize: 10,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'verifyUri',
        content: '{{verifyUri}}',
      },
      {
        type: 'text',
        position: { x: 69.01, y: 51.82 },
        width: 65.1,
        height: 6.55,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'middle',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        fontName: 'liberationSans',
        name: 'referenceId',
        content: '{{referenceId}}',
      },
      {
        name: 'logo',
        type: 'image',
        content: '',
        position: { x: 8.73, y: 9.17 },
        width: 33.64,
        height: 21.48,
        rotate: 0,
        opacity: 1,
        required: false,
        readOnly: false,
      },
      {
        name: 'companyAddress',
        type: 'text',
        content: '{{companyAddress}}',
        position: { x: 44.98, y: 8.73 },
        width: 54.5,
        height: 21.7,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'middle',
        fontSize: 12,
        lineHeight: 1,
        characterSpacing: 1,
        fontColor: '#000000',
        fontName: 'Roboto',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'bankName',
        type: 'text',
        content: '{{bankName}}',
        position: { x: 104.25, y: 11.37 },
        width: 59.8,
        height: 9.79,
        rotate: 0,
        alignment: 'center',
        verticalAlignment: 'middle',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 1,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'faqLink',
        type: 'text',
        content: '{{faqLink}}',
        position: { x: 132.05, y: 234.37 },
        width: 76.99,
        height: 5.82,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'faqPhone',
        type: 'text',
        content: '{{faqLink}}',
        position: { x: 132.05, y: 240.93 },
        width: 76.99,
        height: 5.82,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'faqEmail',
        type: 'text',
        content: '{{faqLink}}',
        position: { x: 132.05, y: 248.55 },
        width: 79.11,
        height: 5.82,
        rotate: 0,
        alignment: 'left',
        verticalAlignment: 'top',
        fontSize: 13,
        lineHeight: 1,
        characterSpacing: 0,
        fontColor: '#000000',
        backgroundColor: '',
        opacity: 1,
        strikethrough: false,
        underline: false,
        required: false,
        readOnly: false,
      },
      {
        name: 'signature',
        type: 'image',
        content: '',
        position: { x: 150.98, y: 52.53 },
        width: 53.97,
        height: 15.08,
        rotate: 0,
        opacity: 1,
        required: false,
        readOnly: false,
      },
    ],
  ],
});

export const previewSampleData: Record<string, string> = {
  nameOnCheck: 'John A. Smith',
  nameOnCheckMiddle: 'John A. Smith',
  nameOnCheckLower: 'John A. Smith',
  amount: '$1,234.56',
  amountInText: 'One Thousand Two Hundred Thirty-Four and 56/100 --------',
  checkDate: '04/14/2026',
  checkDateLower: '04/14/2026',
  checkNumber: '1001',
  checkNumberLower: '1001',
  payTo: 'Acme Corporation',
  payFrom: 'John A. Smith',
  memo: 'Invoice #12345',
  memoBottom: 'Invoice #12345',
  bankInfo: '\u2446021000021\u2446  0123456789\u2446  001001',
  bankName: 'First National Bank',
  companyName: 'Smith Enterprises LLC',
  companyAddress: '123 Main St\nSpringfield, IL 62701',
  compnayAddressMiddle: '123 Main St\nSpringfield, IL 62701',
  referenceId: 'REF-2026-001',
  verifyCode: 'ABC123DEF',
  verifyUri: 'https://app.easyecheck.online/verify/ABC123DEF',
  faqLink: 'https://app.easyecheck.online/faq',
  faqPhone: '(800) 555-0100',
  faqEmail: 'support@easyecheck.online',
  owner: 'https://app.easyecheck.online/',
};

export const examplePdfb64 =
  'data:application/pdf;base64,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';
